<ng-container [formGroup]="addressForm">
  <!-- dynamic: the error message may wrap in narrow columns without overlapping the next field
       (height rule for dynamic subscripts: src/styles/mat-form-field.scss, HOE-1028) -->
  <mat-form-field [class.error-input]="addressControl.invalid && addressControl.touched" appearance="outline"
                  color="accent" subscriptSizing="dynamic">
    <mat-label>{{ title }}</mat-label>
    <input
      formControlName="address"
      matInput
      placeholder=" "
      required
      type="search"
      (keydown.enter)="onKeydownEnter()"
      [matAutocomplete]="auto"
      [tabindex]="tabOrder"
    />

    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onOptionSelected($event)">
      <mat-option *ngFor="let place of (foundedPlaces$ | async)"
                  [value]="place">
        {{ place.formattedAddress }}
      </mat-option>
    </mat-autocomplete>

    <button *ngIf="withClearIcon" mat-icon-button matSuffix>
      <mat-icon>close</mat-icon>
    </button>
    <mat-error>
      <span *ngIf="addressControl.hasError('required')">{{ 'registration.co2.required' | translate }}</span>
      <span *ngIf="addressControl.hasError('addressNotSelected')">{{ 'address.error_not_selected' | translate }}</span>
      <span *ngIf="addressControl.getError('addressIncomplete') as missingPart">{{ 'address.error.title' | translate }} {{ 'address.error_' + missingPart | translate }}</span>
    </mat-error>
  </mat-form-field>
</ng-container>
